// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__2_x5E","footer":"ModalFilter_footer__3jek9"};